import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import useTranslation from 'next-translate/useTranslation'
import ReactSVG from 'react-svg'
import { useRouter } from 'next/router'
import { Preloader } from 'SRC/ui/Preloader'
import Modal from 'react-responsive-modal'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import { getNotifications, getNotificationsLoading } from 'SRC/modules/notifications/selectors'
import { fetchNotifications, readNotification, unreadNotification } from 'SRC/modules/notifications/actions'

const getFormattedDate = (date, withTime = false) => {
	const options = { year: '2-digit', month: '2-digit', day: '2-digit' }
	if (withTime) {
		options.hour = '2-digit'
		options.minute = '2-digit'
	}
	return new Intl.DateTimeFormat('hr-HR', options).format(date)
}

export const Notifications = ({
	notifications,
	isLoading,
	fetchNotifications,
	readNotification,
	unreadNotification,
	isAuthorized
}) => {
	const [showModal, setShowModal] = React.useState(false)
	const [selectedNotificationId, setSelectedNotificationId] = React.useState(null)
	const [showReadOptions, setShowReadOptions] = React.useState(false)

	const { t } = useTranslation('common')

	const router = useRouter()

	useEffect(() => {
		console.log('Notifications isAuthorized:', isAuthorized)

		const cookies = new CookiesHelper()
		const userId = cookies.get('userId')
		const token = cookies.get('token')

		if (isAuthorized && userId && token) {
			fetchNotifications({ userId, token })
		}
	}, [])

	const onCloseModal = () => {
		setShowModal(false)
	}

	const onExited = () => {
		setSelectedNotificationId(null)
	}

	console.log('Notifications component rendered')

	const selectedNotification = notifications.slice().find(n => n.id === selectedNotificationId)

	return (
		<div className='notifications-container'>
			<div className='notifications-header'>
				<button onClick={() => router.back()}>
					<ReactSVG
						src='/icons/back.svg'
						beforeInjection={svg => {
							svg.setAttribute('width', '24px')
							svg.setAttribute('height', '24px')
							svg.querySelector('path').style.fill = '#000000'
						}}
					/>
				</button>
				<h1>{t('Poruke')}</h1>
				<button
					onClick={() => {
						setShowReadOptions(!showReadOptions)
					}}
				>
					<ReactSVG
						src='/icons/more-vert.svg'
						beforeInjection={svg => {
							svg.setAttribute('width', '30px')
							svg.setAttribute('height', '30px')
							svg.querySelector('path').style.fill = '#000000'
						}}
					/>
				</button>

				{showReadOptions ? (
					<div className='notifications-read-options'>
						<p onClick={() => {
							const cookies = new CookiesHelper()
							const userId = cookies.get('userId')
							const token = cookies.get('token')

							if (userId && token) {
								readNotification({ userId, token })
							}
							setShowReadOptions(false)
						}}>{t('Označi sve kao pročitano')}</p>
						<p onClick={() => {
							const cookies = new CookiesHelper()
							const userId = cookies.get('userId')
							const token = cookies.get('token')

							if (userId && token) {
								unreadNotification({ userId, token })
							}
							setShowReadOptions(false)
						}}>{t('Označi sve kao nepročitano')}</p>
					</div>
				) : null}

			</div>

			<div className='notifications-list'>
				{isLoading ? (
					<Preloader />
				) : (
					(notifications || []).map((notification) => (
						<div
							key={notification.id}
							className='notification-item'
							onClick={() => {
								setSelectedNotificationId(notification?.id)
								setShowModal(true)
							}}
						>
							<span className='notification-status' style={{ backgroundColor: notification.read ? '#d9d9d9' : '#e91c23' }} />
							<div style={{ maxWidth: '55%' }}>
								<p className='notification-title' style={{ fontWeight: notification.read ? 'normal' : 'bold' }}>{notification.title}</p>
								<p className='notification-message'>{notification.message}</p>
							</div>
							<p className='notification-date'>{getFormattedDate(new Date(notification.createdAt))}</p>
						</div>
					))
				)}
			</div>

			<Modal
				open={showModal && selectedNotification}
				onClose={onCloseModal}
				center
				closeOnOverlayClick
				showCloseIcon={false}
				onExited={onExited}
				styles={{
					modal: {
						width: '100%',
						margin: 0,
						verticalAlign: 'bottom',
						height: '80vh',
						padding: 0,
					}
				}}
			>
				<>
					<div className='notifications-header notifications-header-modal'>
						<h1>Notifikacija</h1>
					</div>

					<div className='notification-item notification-item-modal'>
						<p className='notification-date'>{selectedNotification && getFormattedDate(new Date(selectedNotification.createdAt), true)}</p>

						<div>
							<span
								className='notification-status'
								style={{ backgroundColor: selectedNotification?.read ? '#d9d9d9' : '#e91c23' }}
								onClick={() => {
									const cookies = new CookiesHelper()
									const userId = cookies.get('userId')
									const token = cookies.get('token')

									if (selectedNotification?.read) {
										if (userId && token && selectedNotificationId) {
											unreadNotification({
												userId,
												token,
												notification: selectedNotificationId
											})
										}
									} else {
										if (userId && token && selectedNotificationId) {
											readNotification({
												userId,
												token,
												notification: selectedNotificationId
											})
										}
									}
								}}
							/>

							<p className='notification-title' style={{ fontWeight: selectedNotification?.read ? 'normal' : 'bold' }}>{selectedNotification?.title}</p>
						</div>
						<p className='notification-message'>{selectedNotification?.message}</p>
					</div>
				</>
			</Modal>
		</div>
	)
}

const mapStateToProps = (state) => ({
	notifications: getNotifications(state),
	isLoading: getNotificationsLoading(state),
	isAuthorized: getIsAuthorized(state)
})

export default connect(mapStateToProps, { fetchNotifications, readNotification, unreadNotification })(Notifications)
